"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QQGS = void 0;
var react_1 = __importStar(require("react"));
var quote_1 = require("../../modules/quote");
var config_1 = require("../../modules/quote/config");
var divscroll_1 = require("../../components/divscroll");
var codes = ["100.AS51", "100.ATX", "100.BFX", "100.BVSP", "100.TSX", "100.PX", "100.FCHI", "100.HEX", "100.GDAXI", "100.AEX", "100.ASE", "100.SENSEX", "100.ICEXI", "100.JKSE", "100.N225", "100.KS11", "100.ISEQ", "100.MIB", "100.KLSE", "100.MXX", "100.NZ50", "100.KSE100", "100.WIG", "100.RTS", "100.OMXSPI", "100.STI", "100.CSEALL", "100.IBEX", "100.SSMI", "100.SET", "100.TWII", "100.FTSE", "100.DJIA", "100.NDX", "100.SPX", "100.VNINDEX"];
/**
 * 全球股市
 */
function QQGS() {
    var _a = (0, react_1.useState)([]), showdata = _a[0], SetShowData = _a[1];
    var getData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var quotedata;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, (0, quote_1.getListQuote)(codes, [
                            config_1.QuoteItem.名称,
                            config_1.QuoteItem.行情统一链接,
                            config_1.QuoteItem.最新价,
                            config_1.QuoteItem.涨跌幅,
                            config_1.QuoteItem.涨跌额
                        ])];
                    case 1:
                        quotedata = _a.sent();
                        if (quotedata.length > 0) {
                            SetShowData(quotedata);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    (0, react_1.useEffect)(function () {
        getData();
        var cd = setInterval(function () {
            getData();
        }, 60 * 1000);
        return function () {
            clearInterval(cd);
        };
    }, []);
    if (showdata.length == 0)
        return react_1.default.createElement(react_1.default.Fragment, null);
    return (react_1.default.createElement(divscroll_1.DivScroll, null,
        react_1.default.createElement(react_1.default.Fragment, null, showdata.map(function (v, index) {
            return react_1.default.createElement(react_1.default.Fragment, { key: index },
                v[config_1.QuoteItem.行情统一链接].html,
                " ",
                v[config_1.QuoteItem.最新价].html,
                " ",
                react_1.default.createElement(UpDownArray, { color: v[config_1.QuoteItem.涨跌额].color }),
                v[config_1.QuoteItem.涨跌额].html,
                " ",
                react_1.default.createElement(UpDownArray, { color: v[config_1.QuoteItem.涨跌额].color }),
                v[config_1.QuoteItem.涨跌幅].html,
                "\u00A0");
        }))));
}
exports.QQGS = QQGS;
/**
 * 上下箭头
 */
function UpDownArray(props) {
    if (props.color == 'price_up') {
        return react_1.default.createElement("span", { className: "price_up" }, "\u2191");
    }
    else if (props.color == 'price_down') {
        return react_1.default.createElement("span", { className: "price_down" }, "\u2193");
    }
    return react_1.default.createElement(react_1.default.Fragment, null);
}
